import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { useIsWideScreen } from "@/hooks/useIsWideScreen";
import { Stack } from "expo-router";
import { Platform } from "react-native";

/** Pre-vetting sub-stack — the step screens share a common progress header. */
export default function PreVettingLayout() {
  const isWide = useIsWideScreen();

  return (
    <Stack
      screenOptions={{
        headerShown: isWide && Platform.OS === "web",
        header: (props) => <ScreenHeader {...props} />,
        animation: "slide_from_right",
      }}
    />
  );
}
